module.exports = __webpack_public_path__ + "media/images/ns-app-header-white-logo3-31a4821759aa033c5c732d58b3709bd1.svg";